import React from "react";
// Customizable Area Start
import {
  Box,
  Typography,
  TextField,
  Chip,
  Button,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  FormHelperText,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  Avatar,
} from "@mui/material";
import { Formik, Form } from "formik";
import {
  aboutImg,
  cameraIcon,
  locationIcon,
  deletePortofolioIcon,
  editPortofolioIcon,
  fbIcon,
  instaIcon,
  xIcon,
  youtubeIcon,
  linkedInIcon,
  profileLocationIcon,
  pdfImg,
  editIcon,
  instagramIcon,
  fbookIcon,
  audioIcon,
} from "./assets";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import PlayCircleRoundedIcon from "@mui/icons-material/PlayCircleRounded";
import AppFooter from "../../../components/src/AppFooter.web";
import CustomisableUserProfilesController, {
  CareerHighlight,
  Category,
  Education,
  LocationOption,
  PortfolioItem,
  Props,
  Skill,
  configJSON,
} from "./CustomisableUserProfilesController";
import CommonModal from "./CommonModal";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import EducationModal from "./EducationModal.web";
import EditCareerHighlights from "./EditCareerHighlights.web";
import BulkUploading from "../../bulkuploading/src/BulkUploading.web";
import FormField from "../../../components/src/FormField.web";
import LanguageList from "../../../components/src/Language.web";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { styled } from "@mui/material/styles";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import FullPageLoader from "../../../components/src/FullPageLoader.web";
import CustomButton from "../../../components/src/CustomButton.web";
import CustomConfirmationDialog from "../../../components/src/CustomConfirmationDialog.web";
import CustomInfoDialog from "../../../components/src/CustomInfoDialog.web";
import { capitalizeFirstLetter } from "../../../components/src/utils";
import PortfolioCarousel from "../../../components/src/PortfolioCarousel.web";
import ImagePreviewDialog from "../../../components/src/ImagePreviewDialog.web";
import PreviousWorkCard from "../../../components/src/PreviousWorkCard.web";
import ShowOrDash from "../../../components/src/ShowOrDash.web";
import GoogleAd from "../../../components/src/GoogleAd.web";

export const TypographyView: typeof Box = styled(Box)({
  "& *": {
    fontFamily: "Montserrat !important",
    fontWeight: 400,
  },
  "& p:last-child": {
    margin: "0 !important",
  },
  "& .profile-bg-img-container": {
    position: "relative",
    height: "425px",
    backgroundColor: "#00000050",
    "& img": {
      objectFit: "cover",
    },
    "@media (max-width: 768px)": {
      height: "300px",
    },
    "@media (max-width: 500px)": {
      height: "260px",
    },
  },
  "& .camera-icon": {
    top: "30px",
    position: "absolute",
    height: "32px",
    width: "32px",
    right: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    border: "1px solid #652784",
    borderRadius: "100px",
    cursor: "pointer",
    "& > img": {
      objectFit: "cover",
    },
  },
  "& .profile-details": {
    position: "relative",
    width: "auto",
    margin: "-157px 100px 0 100px",
    paddingBottom: "100px",
    "@media (max-width: 1279px)": {
      margin: "-157px 16px 0 16px",
      paddingBottom: "40px",
    },
    "@media (max-width: 768px)": {
      marginTop: "-120px",
    },
  },
  "& .profile-container": {
    gap: "50px",
    display: "flex",
    backgroundColor: "#fff",
    padding: "50px",
    borderRadius: "20px",
    marginBottom: "40px",
    "@media (max-width: 415px)": {
      padding: "30px 20px 20px",
    },
    "@media (min-width: 416px) and (max-width: 767px)": {
      padding: "30px",
    },
    "@media (max-width: 767px)": {
      flexDirection: "column",
      alignItems: "center",
      gap: "20px",
    },
    "@media (min-width: 768px) and (max-width: 1023px)": {
      padding: "40px",
    },
  },
  "& .profile-img-container": {
    position: "relative",
    overflow: "hidden",
    width: "189px",
    height: "189px",
    borderRadius: "50%",
    boxShadow: "1px 1px 15px #e2e8f0, 0 4px 6px rgba(0, 0, 0, 0.01)",
  },
  "& .profile-img-camera-icon": {
    position: "absolute",
    top: "152px",
    height: "32px",
    width: "32px",
    right: "20px",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    display: "flex",
    borderRadius: "100px",
    border: "1px solid #652784",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  "& .profile-name-container": {
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "30px",
    display: "flex",
    borderBottom: "1px solid #DFDFDF",
    paddingBottom: "25px",
    "@media (max-width: 767px)": {
      paddingBottom: "12px",
      marginBottom: "15px",
    },
  },
  "& .profile-name-container.name": {
    marginBottom: "14px",
    paddingBottom: "17px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    "@media (max-width: 767px)": {
      paddingBottom: "10px",
      marginBottom: "10px",
    },
  },
  "& .profile-name": {
    fontWeight: "500",
    lineHeight: "31.69px",
    fontSize: "26px",
    color: "#010101",
    "@media (max-width: 414px)": {
      fontSize: "22px",
      lineHeight: "28px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "24px",
      lineHeight: "30px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "28px",
      lineHeight: "34px",
    },
  },
  "& .profile-name.common": {
    lineHeight: "24.38px !important",
    fontSize: "20px !important",
    color: "#000000",
    "@media (max-width: 414px)": {
      lineHeight: "28px !important",
      fontSize: "22px !important",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "18px !important",
      lineHeight: "22px !important",
    },
    "@media (min-width: 1600px)": {
      lineHeight: "34px !important",
      fontSize: "22px !important",
    },
  },
  "& .profile-details-com-container": {
    paddingBottom: "13px",
    marginBottom: "14px",
    display: "flex",
    borderBottom: "1px solid #DFDFDF",
    "@media (max-width: 1023px)": {
      flexWrap: "wrap",
      gap: "10px",
    },
  },
  "& .profile-details-location, & .profile-details-languages": {
    alignItems: "center",
    display: "flex",
    fontWeight: "500",
    lineHeight: "16.88px",
    fontSize: "14px",
    paddingLeft: "22px",
    color: "#9B9B9D",
    "@media (max-width: 1023px)": {
      paddingLeft: "5px",
      flexWrap: "wrap",
    },
  },
  "& .profile-details-location span": {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    width: "200px",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "16.88px",
    color: "#010101",
    paddingLeft: "22px",
    "@media (max-width: 1023px)": {
      width: "auto",
      paddingLeft: "5px",
    },
  },
  "& .profile-details-languages": {
    gap: "8px",
  },
  "& .profile-details-languages span": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "16px",
    color: "#010101",
  },
  "& .profile-details-weight, & .profile-details-weight span": {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "16px",
    color: "#9B9B9D",
    "@media (max-width: 1023px)": {
      gap: "8px",
      paddingLeft: "5px",
    },
  },
  "& .profile-about-container": {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding: "50px",
    marginBottom: "40px",
    "@media (max-width: 415px)": {
      padding: "16px",
      marginBottom: "20px",
    },
    "@media (min-width: 416px) and (max-width: 767px)": {
      padding: "30px",
      marginBottom: "20px",
    },
    "@media (min-width: 768px) and (max-width: 1023px)": {
      padding: "40px",
      marginBottom: "30px",
    },
  },
  "& .profile-about-desc": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "24px",
    fontFamily: "Montserrat !important",
    color: "#000",
    textAlign: "justify",
    "@media (max-width: 414px)": {
      fontSize: "12px",
      lineHeight: "20px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "14px",
      lineHeight: "22px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "18px",
      lineHeight: "26px",
    },
  },
  "& .profile-educ": {
    display: "flex",
    gap: "75px",
    marginBottom: "30px",
    paddingBottom: "30px",
    borderBottom: "1px solid #DFDFDF",
    width: "100%",
    "@media (max-width: 767px)": {
      flexDirection: "column",
      gap: "20px",
      marginBottom: "12px",
      paddingBottom: "12px",
      "& .career-highlight-image": {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        "& img": {
          maxHeight: "90px",
          maxWidth: "90px",
          height: "100%",
          width: "100%",
        },
      },
    },
  },
  "& .profile-educ-details h3": {
    fontSize: "24px",
    fontWeight: "500",
    lineHeight: "30px",
    marginBottom: "12px",
    "@media (max-width: 414px)": {
      fontSize: "20px",
      lineHeight: "26px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "22px",
      lineHeight: "28px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "26px",
      lineHeight: "32px",
    },
  },
  "& .profile-educ-details p": {
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "20px",
    marginBottom: "8px",
    textAlign: "justify",
    "@media (max-width: 414px)": {
      fontSize: "12px",
      lineHeight: "16px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "14px",
      lineHeight: "18px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "18px",
      lineHeight: "22px",
    },
  },
  "& .profile-educ-details span": {
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    color: "#9B9B9D",
    "@media (max-width: 414px)": {
      fontSize: "10px",
      lineHeight: "16px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "12px",
      lineHeight: "18px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "16px",
      lineHeight: "22px",
    },
  },
  "& .profile-educ-location": {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  "& .profile-links": {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
    gap: "20px",
    "@media (max-width: 414px)": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
    "@media (min-width: 415px) and (max-width: 600px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (min-width: 601px) and (max-width: 1023px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
  "& .profile-links span": {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "19px",
    color: "#000",
    "@media (max-width: 414px)": {
      fontSize: "12px",
      lineHeight: "15px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "14px",
      lineHeight: "17px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "18px",
      lineHeight: "21px",
    },
  },
  "& .profile-portfolios": {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
    gap: "20px",
    "@media (max-width: 414px)": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
    "@media (min-width: 415px) and (max-width: 600px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (min-width: 601px) and (max-width: 1023px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
  "& .profile-portfolio-img": {
    position: "relative",
    width: "100%",
    maxWidth: "300px",
    aspectRatio: "268 / 316",
    borderRadius: "10px",
    overflow: "hidden",
    backgroundColor: "#D7E8FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    ["@supports not (aspect-ratio: 1)"]: {
      height: 0,
      paddingBottom: "117.91%",
    },
  },
  "& .portfolio-video-icon": {
    position: "absolute",
    top: "15px",
    left: "15px",
    color: "#652784",
    zIndex: 9,
  },
  "& .portfolio-media": {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "auto",
    "& .portfolio-media-inner": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      "& img": {
        height: "100%",
        width: "100%",
        maxHeight: "150px",
        maxWidth: "150px",
      },
    },
  },
  "& .profile-portfolio-icons": {
    position: "absolute",
    bottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    width: "100%",
    zIndex: "1",
  },
  "& .profile-portfolio-play": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    backgroundColor: "#65278480",
    borderRadius: "10px",
  },
  "& .profile-portfolio-icons div, & .profile-portfolio-play div": {
    height: "32px",
    width: "32px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: "100px",
    cursor: "pointer",
  },
  "& .profile-skills-container": {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
  },
  "& .profile-skills-outer-chip": {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    alignItems: "center",
    backgroundColor: "#EFF6FF",
    padding: "6px 24px",
    borderRadius: "26px",
  },
  "& .profile-skills-outer-chip p": {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "22px",
    color: "#0F172A",
    "@media (max-width: 414px)": {
      fontSize: "10px",
      lineHeight: "18px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "12px",
      lineHeight: "20px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "16px",
      lineHeight: "24px",
    },
  },
  "& .profile-skills-inner-chip": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  "& .profile-skills-chip": {
    backgroundColor: "#fff",
    border: "1px solid #CBD5E1",
  },
  "& .profile-skills-chip span": {
    fontSize: "14px",
    color: "#0F172A",
    fontWeight: "500",
    lineHeight: "22px",
    "@media (max-width: 414px)": {
      fontSize: "10px",
      lineHeight: "18px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "12px",
      lineHeight: "20px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "16px",
      lineHeight: "24px",
    },
  },
  "& .profile-skills-dots": {
    display: "flex",
    gap: "4px",
  },
  "& .profile-skills-dots span": {
    display: "inline-block",
    height: "6px",
    width: "6px",
    borderRadius: "100px",
  },
  "& .profile-skills-inner-chip div span.skills-filled-circle": {
    backgroundColor: "#059669",
  },
  "& .profile-skills-inner-chip div span.skills-empty-circle": {
    backgroundColor: "#94A3B8",
  },
  "& .profile-social-links": {
    display: "flex",
    gap: "13px",
  },
  "& .profile-social-links div": {
    height: "50px",
    width: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    border: "2px solid #652784",
    borderRadius: "100px",
    cursor: "pointer",
    overflow: "hidden",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.05)",
    },
    "& > a": {
      height: "100%",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        height: "18px",
        width: "18px",
      },
    },
    "@media (max-width: 767px)": {
      height: "40px",
      width: "40px",
    },
  },
});

type SocialMediaLinks = {
  facebookLink: string;
  instagramLink: string;
  X: string;
  youtubeLink: string;
  linkedinLink: string;
};
// Customizable Area End
// Customizable Area End

export default class CustomisableUserProfiles extends CustomisableUserProfilesController {
  fileInput = React.createRef<HTMLInputElement>();
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  canEditProfile = () => {
    const { loggedInUserId, selectedUserId } = this.state;
    return (
      loggedInUserId && (!selectedUserId || loggedInUserId === selectedUserId)
    );
  };

  renderSocialIcons = () => {
    const { socialLinks } = this.state;
    const SOCIAL_ICONS = [
      {
        key: "facebookLink" as keyof SocialMediaLinks,
        icon: fbIcon,
        alt: "facebook-icon",
      },
      {
        key: "instagramLink" as keyof SocialMediaLinks,
        icon: instaIcon,
        alt: "insta-icon",
      },
      { key: "X" as keyof SocialMediaLinks, icon: xIcon, alt: "x-icon" },
      {
        key: "youtubeLink" as keyof SocialMediaLinks,
        icon: youtubeIcon,
        alt: "youtube-icon",
      },
      {
        key: "linkedinLink" as keyof SocialMediaLinks,
        icon: linkedInIcon,
        alt: "linkedin-icon",
      },
    ];
    const validLinks = SOCIAL_ICONS.filter(({ key }) => socialLinks[key]);
    return (
      <Box className="profile-social-links">
        {validLinks.length === 0 ? (
          <Typography>No social links added</Typography>
        ) : (
          validLinks.map(({ key, icon, alt }) => (
            <Box key={String(key)}>
              <a
                href={socialLinks[key]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Box component="img" src={icon} alt={alt} />
              </a>
            </Box>
          ))
        )}
      </Box>
    );
  };

  renderSelectedPortfolioMedia = () => {
    if (!this.state.selectedPortfolioImage) return null;
    const mediaProps = { width: "100%", height: "100%" };
    const mediaTypes = {
      image: (
        <Box
          component="img"
          src={this.state.selectedPortfolioImage.url}
          alt="edit-profile-img"
          {...mediaProps}
        />
      ),
      video: (
        <Box
          component="video"
          src={this.state.selectedPortfolioImage.url}
          controls
          playsInline
          {...mediaProps}
        />
      ),
      pdf: <Box component="img" src={pdfImg} {...mediaProps} />,
      audio: <Box component="img" src={audioIcon} {...mediaProps} />,
    };
    return (
      mediaTypes[
        this.state.selectedPortfolioImage.type as keyof typeof mediaTypes
      ] || null
    );
  };

  ClickableImage = ({
    src,
    alt,
    borderRadius = "0px",
    onClick,
  }: {
    src?: string | undefined;
    alt?: string;
    borderRadius?: string;
    onClick?: () => void;
  }) => {
    return (
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: "100%",
          height: "100%",
          cursor: src ? "pointer" : "default",
          borderRadius,
          objectFit: "cover",
        }}
        onClick={onClick}
      />
    );
  };

  renderCoverImage = () => {
    return (
      <Box className="profile-bg-img-container" data-test-id="coverImg">
        {this.renderImage(this.state.coverImgPreview ?? undefined)}
        {this.canEditProfile() && (
          <Box className="camera-icon">
            <Box
              data-test-id="coverPhoto"
              component={"img"}
              src={cameraIcon}
              alt="camera-icon"
              onClick={() => this.handleCoverPhoto(true)}
            />
          </Box>
        )}
      </Box>
    );
  };

  renderImage = (preview: string | undefined) => {
    const src = preview;
    if (!src) return null;

    return (
      <this.ClickableImage
        src={src}
        data-test-id="handleMediaClickBtn"
        onClick={() => this.handleMediaClick(preview)}
      />
    );
  };

  groupedSkills: Record<string, Skill[]> = this.state.savedSkills.reduce(
    (acc, skill) => {
      if (!acc[skill.category]) acc[skill.category] = [];
      acc[skill.category].push(skill);
      return acc;
    },
    {} as Record<string, Skill[]>
  );

  renderMediaContent = (item: PortfolioItem) => {
    switch (item.type) {
      case "image":
        return (
          <Box
            component="img"
            data-test-id="previewImage"
            src={item.url}
            alt={`portfolio-img-${item.id}`}
            className="portfolio-media"
          />
        );
      case "video":
        return (
          <video
            muted
            playsInline
            src={item.url}
            controls={false}
            autoPlay={false}
            preload="metadata"
            className="portfolio-media"
          />
        );
      case "audio":
        return (
          <Box className="portfolio-media">
            <Box className="portfolio-media-inner">
              <Box
                component="img"
                src={audioIcon}
                title={`portfolio-audio-${item.id}`}
                alt="portfolio-audio"
              />
            </Box>
          </Box>
        );
      case "application/pdf":
        return (
          <Box className="portfolio-media">
            <Box className="portfolio-media-inner">
              <Box
                component="img"
                src={pdfImg}
                title={`portfolio-pdf-${item.id}`}
                alt="portfolio-pdf"
              />
            </Box>
          </Box>
        );
      default:
        return null;
    }
  };

  renderPortfolioIcons = (index: number) => {
    return (
      <Box className="profile-portfolio-icons">
        {this.canEditProfile() && (
          <>
            <Box
              onClick={(event) => this.handleEditImage(event, index)}
              data-test-id="editportfolioBtn"
            >
              <Box component="img" src={editPortofolioIcon} alt="edit-icon" />
            </Box>
            <Box
              onClick={(event) => this.handleDeleteImage(event, index)}
              data-test-id="deleteportfolioBtn"
            >
              <Box
                component="img"
                src={deletePortofolioIcon}
                alt="delete-icon"
              />
            </Box>
          </>
        )}
      </Box>
    );
  };

  renderPortfolioItem = (item: PortfolioItem, index: number) => {
    return (
      <Box
        key={String(item.id)}
        className="profile-portfolio-img"
        onClick={() => this.openPortfolioDialog(index)}
      >
        {item.type === "video" && (
          <PlayCircleRoundedIcon className="portfolio-video-icon" />
        )}
        {this.renderMediaContent(item)}
        {this.renderPortfolioIcons(index)}
      </Box>
    );
  };

  renderPortfolioImages = () => {
    const { portfolioImgs, isPortfolioDialog, initialPortfolioIndex } =
      this.state;
    if (!Array.isArray(portfolioImgs) || portfolioImgs.length === 0) {
      return this.canEditProfile() ? null : (
        <Typography variant="body1">No portfolio available</Typography>
      );
    }
    return (
      <>
        {portfolioImgs.map((item, index) =>
          this.renderPortfolioItem(item, index)
        )}
        <PortfolioCarousel
          open={isPortfolioDialog}
          items={portfolioImgs}
          currentActiveIndex={initialPortfolioIndex}
          onClose={this.closePortfolioDialog}
        />
      </>
    );
  };

  renderPortfolioSection = () => {
    return (
      <Box className="profile-about-container">
        <Box className="profile-name-container">
          <Typography component="h2" className="profile-name common">
            Portfolio
          </Typography>
        </Box>
        <Box className="profile-portfolios" data-test-id="portfolioImage">
          {this.renderPortfolioImages()}
          {this.canEditProfile() && (
            <BulkUploading
              navigation={undefined}
              id={""}
              data-test-id="handleUploadedFiles"
              onFilesUploaded={this.handleUploadedFiles}
              portfolioImgs={this.state.portfolioImgs}
            />
          )}
        </Box>
      </Box>
    );
  };

  renderProfileDetails = () => {
    const {
      isLoading,
      profileImgPreview,
      profileData: {
        age,
        role,
        height,
        weight,
        location,
        lastName,
        firstName,
        userGender,
        selectedLanguages,
      },
    } = this.state;
    const fullName = `${firstName} ${lastName}`;

    return (
      <Box>
        <Box className="profile-container">
          <Box sx={{ position: "relative" }}>
            <Box
              data-test-id="profileImg"
              className="profile-img-container"
              sx={{ backgroundColor: "#00000050" }}
            >
              {this.renderImage(profileImgPreview ?? undefined)}
              <Avatar
                src={profileImgPreview || ""}
                alt={fullName}
                data-test-id="handleMediaClickBtn"
                sx={{ height: "100%", width: "100%", cursor: "pointer" }}
                onClick={() => this.handleMediaClick(profileImgPreview)}
              />
            </Box>
            {this.canEditProfile() && (
              <IconButton className="profile-img-camera-icon">
                <Box
                  data-test-id="profilePhoto"
                  component={"img"}
                  src={cameraIcon}
                  alt="camera-icon"
                  onClick={() => this.modalVisible(true)}
                />{" "}
              </IconButton>
            )}
          </Box>
          <Box sx={{ width: "100%" }}>
            <Box className="profile-name-container name">
              <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography component="h2" className="profile-name">
                  {fullName}
                </Typography>
                {this.canEditProfile() && (
                  <IconButton>
                    <Box
                      component={"img"}
                      data-test-id="handleBasicModal"
                      src={editIcon}
                      alt="edit-icon"
                      onClick={() => this.handleBasicModal()}
                    />
                  </IconButton>
                )}
              </Box>
              <Box display="flex" alignItems="center" gap="10px">
                {!isLoading && (
                  <>
                    {!this.canEditProfile() && (
                      <CustomButton
                        customVariant="filled"
                        sx={{ fontSize: "14px", padding: "8px 15px" }}
                        startIcon={<MailOutlineRoundedIcon />}
                        onClick={this.handleSendMessage}
                      >
                        Message
                      </CustomButton>
                    )}
                    <CustomButton
                      customVariant="contained"
                      sx={{ fontSize: "14px", padding: "6px 15px" }}
                      startIcon={<ContentCopyRoundedIcon />}
                      onClick={this.handleCopyProfileLink}
                    >
                      Copy
                    </CustomButton>
                  </>
                )}
              </Box>
            </Box>
            <Box className="profile-details-com-container">
              <Box className="profile-details-location">
                Location:
                <Typography component="span">
                  <ShowOrDash condition={!!location}>
                    <Box
                      component={"img"}
                      src={profileLocationIcon}
                      alt="location-icon"
                      sx={{ color: "#010101" }}
                    />
                    {location}
                  </ShowOrDash>
                </Typography>
              </Box>
              <Box
                sx={{
                  paddingLeft: "0px !important",
                  "@media (max-width: 1023px)": {
                    paddingLeft: "5px !important",
                  },
                }}
                className="profile-details-languages"
              >
                Languages Spoken:
                <LanguageList items={selectedLanguages} visibleCount={4} />
              </Box>
            </Box>
            <Box className="profile-details-com-container">
              <Box
                className="profile-details-location"
                sx={{ "@media (min-width: 1024px)": { gap: "8px !important" } }}
              >
                Height:
                <Typography
                  component="span"
                  sx={{
                    "@media (min-width: 1024px)": { width: "204px !important" },
                  }}
                >
                  <ShowOrDash condition={!isNaN(Number(height))}>
                    {height} cm
                  </ShowOrDash>
                </Typography>
              </Box>
              <Box className="profile-details-weight">
                Weight:
                <Typography
                  component="span"
                  sx={{
                    width: "138px",
                    color: "#010101 !important",
                    "@media (max-width: 1023px)": { width: "auto" },
                  }}
                >
                  <ShowOrDash condition={!isNaN(Number(weight))}>
                    {weight} kg
                  </ShowOrDash>
                </Typography>
              </Box>
              <Box className="profile-details-weight">
                Age:
                <Typography
                  component="span"
                  sx={{ color: "#010101 !important" }}
                >
                  <ShowOrDash condition={!isNaN(Number(age))}>
                    {age} Years
                  </ShowOrDash>
                </Typography>
              </Box>
            </Box>
            <Box
              className="profile-details-com-container"
              sx={{ marginBottom: "0 !important" }}
            >
              <Box
                className="profile-details-location"
                sx={{ "@media (min-width: 1024px)": { gap: "8px !important" } }}
              >
                Gender:
                <Typography
                  component="span"
                  sx={{ width: "201px", color: "#010101" }}
                >
                  <ShowOrDash condition={!!userGender}>
                    {capitalizeFirstLetter(userGender)}
                  </ShowOrDash>
                </Typography>
              </Box>
              <Box className="profile-details-weight">
                Role:
                <Typography
                  component="span"
                  sx={{ color: "#010101 !important" }}
                >
                  {role}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  renderProfessionalSkills = () => {
    return (
      <Box className="profile-about-container">
        <Box className="profile-name-container">
          <Typography component="h2" className="profile-name common">
            {" "}
            Professional Skills{" "}
          </Typography>
          {this.canEditProfile() && (
            <IconButton>
              <Box
                component={"img"}
                data-test-id="openProfessionalModal"
                src={editIcon}
                alt="edit-icon"
                onClick={() => this.handleProfessionalModal(true)}
              />
            </IconButton>
          )}
        </Box>
        <Box className="profile-skills-container">
          {this.state.categories && this.state.categories.length > 0 ? (
            this.state.categories.map(
              (
                category: {
                  name: string | number | boolean;
                  sub_categories: any[];
                },
                categoryIndex: number
              ) => (
                <Box key={categoryIndex} className="profile-skills-outer-chip">
                  <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    {category.name}
                  </Typography>
                  {category.sub_categories &&
                  category.sub_categories.length > 0 ? (
                    category.sub_categories.map((subSkill, subIndex) => (
                      <Box
                        key={subIndex}
                        sx={{ display: "flex", flexWrap: "wrap" }}
                      >
                        <Box className="profile-skills-inner-chip">
                          <Chip
                            label={subSkill.name}
                            data-test-id="profile-skills-chip"
                            className="profile-skills-chip"
                          />
                          <Box className="profile-skills-dots">
                            {Array.from({ length: 3 }, (_, i) => (
                              <Typography
                                key={i}
                                component="span"
                                data-test-id={
                                  i <
                                  this.getDotCount(subSkill.experience_level)
                                    ? "filled-dot"
                                    : "empty-dot"
                                }
                                className={
                                  i <
                                  this.getDotCount(subSkill.experience_level)
                                    ? "skills-filled-circle"
                                    : "skills-empty-circle"
                                }
                              />
                            ))}
                          </Box>
                        </Box>
                      </Box>
                    ))
                  ) : (
                    <Typography variant="body2" sx={{ fontStyle: "italic" }}>
                      No sub-skills available
                    </Typography>
                  )}
                </Box>
              )
            )
          ) : (
            <Typography variant="body1">No categories available</Typography>
          )}
        </Box>
      </Box>
    );
  };

  renderAboutDetails = () => {
    return (
      <Box className="profile-about-container">
        <Box className="profile-name-container">
          <Typography component="h2" className="profile-name common">
            {" "}
            About {this.state.profileData.firstName}{" "}
            {this.state.profileData.lastName}{" "}
          </Typography>
          {this.canEditProfile() && (
            <IconButton
              data-test-id="aboutUser"
              sx={{ cursor: "pointer" }}
              onClick={() => this.handleEditAbout(true)}
            >
              <Box component={"img"} src={editIcon} alt="edit-icon" />
            </IconButton>
          )}
        </Box>
        {this.state.aboutDetails ? (
          <Typography className="profile-about-desc">
            {this.state.aboutDetails}
          </Typography>
        ) : (
          <Typography variant="body1">No about details available</Typography>
        )}
      </Box>
    );
  };

  renderCareerHightlights = () => {
    return (
      <Box className="profile-about-container">
        <Box className="profile-name-container">
          <Typography component="h2" className="profile-name common">
            {" "}
            Career Highlights{" "}
          </Typography>
          {this.canEditProfile() && (
            <IconButton
              data-test-id="careerUser"
              onClick={() => this.handleEditCareer(null)}
            >
              <Box component={"img"} src={editIcon} alt="edit-icon" />
            </IconButton>
          )}
        </Box>
        <Box>
          {this.state.careerHighlights.length === 0 ? (
            <Typography>No career highlights available</Typography>
          ) : (
            this.state.careerHighlights.map(
              (highlight: CareerHighlight, index: number) => {
                const {
                  career_images_urls = [],
                  project_name,
                  role,
                  start_date,
                  start_year,
                  end_date,
                  end_year,
                  ongoing,
                  duration,
                  location,
                  description,
                  project_link,
                } = highlight.attributes || {};
                const imageUrls =
                  career_images_urls && typeof career_images_urls === "string"
                    ? [career_images_urls]
                    : Array.isArray(career_images_urls)
                    ? career_images_urls
                    : [];

                const isOngoing =
                  ongoing ||
                  !end_date?.toString().trim() ||
                  !end_year?.toString().trim();
                return (
                  <Box key={index} className="profile-educ">
                    <Box
                      className="career-highlight-image"
                      sx={{
                        height: "90px",
                        width: "90px",
                        borderRadius: "100px",
                        cursor:
                          career_images_urls.length > 0 ? "pointer" : "default",
                      }}
                    >
                      <this.ClickableImage
                        src={imageUrls[0]}
                        borderRadius="100px"
                        onClick={() => this.handleMediaClick(imageUrls[0])}
                      />
                    </Box>
                    <Box
                      className="profile-educ-details"
                      sx={{
                        "@media (min-width: 768px)": {
                          width: "calc(100% - 150px)",
                        },
                      }}
                    >
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography component={"h3"}>{project_name}</Typography>
                        {this.canEditProfile() && (
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <IconButton
                              data-test-id="careereditUser"
                              onClick={() => this.handleEditCareer(highlight)}
                            >
                              <Box
                                component="img"
                                src={editIcon}
                                alt="edit-icon"
                                height="18px"
                                width="18px"
                              />
                            </IconButton>
                            <IconButton
                              data-test-id={`deleteCareerHighlight-${highlight.id}`}
                              sx={{ color: "#94A3B8" }}
                              onClick={() =>
                                this.handleDeleteCareerHighlightModal(
                                  highlight.id,
                                  index
                                )
                              }
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        )}
                      </Box>
                      <Typography>{role}</Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          marginBottom: "16px !important",
                        }}
                      >
                        <Typography component="span">
                          {start_date} {start_year} -{" "}
                          {isOngoing ? "Ongoing" : `${end_date} ${end_year}`}
                        </Typography>
                        <Box
                          sx={{
                            height: "16px",
                            width: "1px",
                            borderRight: "1px solid #64748B",
                          }}
                        ></Box>
                        <Typography component="span">{duration}</Typography>
                        <Box
                          sx={{
                            height: "16px",
                            width: "1px",
                            borderRight: "1px solid #64748B",
                          }}
                        ></Box>
                        <Typography
                          component="span"
                          className="profile-educ-location"
                        >
                          <Box
                            component={"img"}
                            src={locationIcon}
                            alt="location-icon"
                            sx={{ color: "#010101" }}
                          />
                          {location}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontWeight: "300 !important",
                          marginBottom: "16px",
                          wordBreak: "break-word",
                        }}
                      >
                        {description}
                      </Typography>
                      <Typography
                        component="a"
                        href={project_link}
                        target="_blank"
                        sx={{
                          fontWeight: "300 !important",
                          wordBreak: "break-word",
                        }}
                      >
                        {project_link}
                      </Typography>
                    </Box>
                  </Box>
                );
              }
            )
          )}
        </Box>
      </Box>
    );
  };

  renderEducation = () => {
    return (
      <Box className="profile-about-container">
        <Box className="profile-name-container">
          <Typography component="h2" className="profile-name common">
            {" "}
            Education and Training{" "}
          </Typography>
          {this.canEditProfile() && (
            <IconButton>
              <Box
                component={"img"}
                src={editIcon}
                alt="edit-icon"
                data-test-id="educationEditBtn"
                onClick={() => this.handleEducationModal(null)}
              />
            </IconButton>
          )}
        </Box>
        <Box>
          {this.state.educationDetails.length === 0 ? (
            <Typography>No education details available</Typography>
          ) : (
            this.state.educationDetails.map(
              (education: Education, index: number) => {
                const {
                  institute_name,
                  qualification,
                  start_date,
                  end_date,
                  start_year,
                  end_year,
                  is_ongoing,
                  location,
                } = education.attributes || {};
                const isOngoing =
                  is_ongoing ||
                  !end_date?.toString().trim() ||
                  !end_year?.toString().trim();
                return (
                  <Box key={index} className="profile-educ">
                    <Box
                      sx={{
                        height: "75px",
                        width: "75px",
                        borderRadius: "100px",
                      }}
                    >
                      <Box
                        component={"img"}
                        src={aboutImg}
                        alt="about-img"
                        sx={{ height: "100%", width: "100%" }}
                      />
                    </Box>
                    <Box
                      className="profile-educ-details"
                      sx={{
                        "@media (min-width: 768px)": {
                          width: "calc(100% - 150px)",
                        },
                      }}
                    >
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography component={"h3"}>
                          {institute_name}
                        </Typography>
                        {this.canEditProfile() && (
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <IconButton
                              data-test-id="careerUser"
                              onClick={() =>
                                this.handleEducationModal(education)
                              }
                            >
                              <Box
                                component={"img"}
                                src={editIcon}
                                alt="edit-icon"
                                height="18px"
                                width="18px"
                              />
                            </IconButton>
                            <IconButton
                              data-test-id="deleteEducation"
                              sx={{ color: "#94A3B8" }}
                              onClick={() =>
                                this.handleDeleteEducation(education.id, index)
                              }
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        )}
                      </Box>
                      <Typography>{qualification}</Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <Typography component="span">
                          {start_date} {start_year} -{" "}
                          {isOngoing ? "Ongoing" : `${end_date} ${end_year}`}
                        </Typography>
                        <Typography
                          component="span"
                          className="profile-educ-location"
                        >
                          <Box
                            component={"img"}
                            src={locationIcon}
                            alt="location-icon"
                            sx={{ color: "#010101" }}
                          />
                          {location}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                );
              }
            )
          )}
        </Box>
      </Box>
    );
  };

  renderPortfolioLinks = () => {
    return (
      <Box className="profile-about-container">
        <Box className="profile-name-container">
          <Typography component="h2" className="profile-name common">
            {" "}
            Previous Work{" "}
          </Typography>
          {this.canEditProfile() && (
            <IconButton>
              <Box
                component={"img"}
                src={editIcon}
                alt="edit-icon"
                data-test-id="portfolioEditBtn"
                onClick={() => this.handlePortfolioModal()}
              />
            </IconButton>
          )}
        </Box>
        <Box className="profile-links" data-test-id="portfolioLinkBox">
          {Object.values(this.state.portfolioLinks).every((link) => !link) ? (
            <Typography>No previous work available</Typography>
          ) : (
            <>
              {Object.values(this.state.portfolioLinks)
                .filter((link) => link !== "")
                .map((link) => (
                  <PreviousWorkCard key={link} url={link} />
                ))}
            </>
          )}
        </Box>
      </Box>
    );
  };

  renderSocialMediaLinks = () => {
    return (
      <Box
        className="profile-about-container"
        sx={{ marginBottom: "0px !important" }}
      >
        <Box className="profile-name-container">
          <Typography component="h2" className="profile-name common">
            Social Media Links
          </Typography>
          {this.canEditProfile() && (
            <IconButton>
              <Box
                component={"img"}
                src={editIcon}
                alt="edit-icon"
                data-test-id="socialEditBtn"
                onClick={() => this.handleSocialModal()}
              />
            </IconButton>
          )}
        </Box>
        <Box data-test-id="socialLinks">{this.renderSocialIcons()}</Box>
      </Box>
    );
  };

  groupSkillsByCategory = (
    skills: { category: string; subCategory: string; level: string }[]
  ) => {
    return skills.reduce((acc, skill) => {
      if (!acc[skill.category]) acc[skill.category] = [];
      acc[skill.category].push(skill);
      return acc;
    }, {} as Record<string, { subCategory: string; level: string }[]>);
  };

  getInitialSocialLinks = (): SocialMediaLinks => {
    const defaultLinks = {
      facebookLink: "",
      instagramLink: "",
      X: "",
      youtubeLink: "",
      linkedinLink: "",
    };

    return {
      ...defaultLinks,
      ...this.state.socialLinks,
    };
  };

  renderExpandedImage = () => (
    <Box>
      <img
        src={this.state.expandedMedia || ""}
        alt="Expanded View"
        style={{
          width: "100%",
          height: "60%",
          borderRadius: "8px",
          transition: "transform 0.3s ease-in-out",
          transform: "scale(1.02)",
        }}
      />
    </Box>
  );

  renderExpandedAudio = () => (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Box
        sx={{ height: 100, width: 100 }}
        component="img"
        src={audioIcon}
        alt="Audio Icon"
      />
      <audio controls style={{ width: "100%", marginTop: 8 }}>
        <source src={this.state.expandedMedia || ""} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </Box>
  );

  renderCategorySelect = () => (
    <Box sx={{ width: "100%" }}>
      <Typography>Select your Categories</Typography>
      <FormControl fullWidth sx={{ ...webStyle.input }}>
        <Select
          value={this.state.selectedCategory}
          data-test-id="categorySelect"
          IconComponent={KeyboardArrowDownRoundedIcon}
          onChange={this.handleCategoryChange}
          displayEmpty
        >
          <MenuItem value="" sx={{ display: "none" }}>
            Select your skills
          </MenuItem>
          {this.state.categoriesList.length > 0 ? (
            this.state.categoriesList.map((category: Category) => (
              <MenuItem key={category.id} value={category.name}>
                {category.name}
              </MenuItem>
            ))
          ) : (
            <MenuItem value="" disabled>
              No categories available
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </Box>
  );

  renderSubCategorySelect = () => (
    <Box sx={{ width: "100%" }}>
      <Typography>Sub Categories</Typography>
      <FormControl fullWidth sx={{ ...webStyle.input }}>
        <Select
          data-test-id="subCategorySelect"
          multiple
          disabled={
            !this.state.selectedCategory ||
            this.state.subCategories.length === 0
          }
          IconComponent={KeyboardArrowDownRoundedIcon}
          value={this.state.selectedSubCategory || []}
          onChange={this.handleSubCategoryChange}
          onClose={this.handleDropdownClose}
          displayEmpty
          renderValue={(selected) =>
            Array.isArray(selected) && selected.length > 0
              ? selected.join(", ")
              : "Select your sub categories"
          }
        >
          {this.state.subCategories.map((sub: string) => (
            <MenuItem key={sub} value={sub}>
              <Checkbox
                checked={this.state.selectedSubCategory.includes(sub)}
              />
              {sub}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );

  renderSelectedSkills = () => {
    const groupedSkills = this.groupSkillsByCategory(this.state.selectedSkills);

    return Object.entries(groupedSkills).map(
      ([category, skills], categoryIndex) => (
        <Box key={categoryIndex} sx={{ mb: 2 }}>
          <Typography sx={{ fontWeight: "bold", mt: 2 }}>{`${
            categoryIndex + 1
          }. ${category}`}</Typography>
          {skills.map((skill, subIndex) => (
            <Box sx={{ ...webStyle.categoryListing }} key={subIndex}>
              <Typography sx={{ flex: 1 }}>
                {`${this.convertToRoman(subIndex + 1)}. ${skill.subCategory}`}
              </Typography>
              <FormControl component="fieldset">
                <RadioGroup
                  data-test-id="skillLevelGroup"
                  row
                  value={skill.level}
                  onChange={(e) =>
                    this.handleSkillLevelChange(
                      this.state.selectedSkills.findIndex(
                        (s) =>
                          s.subCategory === skill.subCategory &&
                          s.category === category
                      ),
                      e.target.value as "Beginner" | "Intermediate" | "Expert"
                    )
                  }
                >
                  <FormControlLabel
                    value="Beginner"
                    control={<Radio />}
                    label="Beginner"
                  />
                  <FormControlLabel
                    value="Intermediate"
                    control={<Radio />}
                    label="Intermediate"
                  />
                  <FormControlLabel
                    value="Expert"
                    control={<Radio />}
                    label="Expert"
                  />
                </RadioGroup>
              </FormControl>

              <IconButton
                sx={{ ...webStyle.deleteBtn }}
                data-test-id={`deleteSkill-${skill.subCategory}`}
                onClick={() => this.handleDeleteSkill(skill.subCategory)}
              >
                <DeleteOutlineIcon color="error" />
              </IconButton>
            </Box>
          ))}
        </Box>
      )
    );
  };

  socialMediaFields = [
    {
      name: "facebookLink",
      label: "Facebook",
      icon: (
        <img src={fbookIcon} alt="Facebook" style={{ width: 24, height: 24 }} />
      ),
      placeholder: "Please add your Facebook URL here",
    },
    {
      name: "instagramLink",
      label: "Instagram",
      icon: (
        <img
          src={instagramIcon}
          alt="Instagram"
          style={{ width: 24, height: 24 }}
        />
      ),
      placeholder: "Please add your Instagram URL here",
    },
    {
      name: "X",
      label: "Twitter",
      icon: <img src={xIcon} alt="X" style={{ width: 20, height: 20 }} />,
      placeholder: "Please add your Twitter URL here",
    },
    {
      name: "youtubeLink",
      label: "YouTube",
      icon: <YouTubeIcon style={{ color: "#FF0100" }} />,
      placeholder: "Please add your YouTube URL here",
    },
    {
      name: "linkedinLink",
      label: "LinkedIn",
      icon: <LinkedInIcon style={{ color: "#0273AF" }} />,
      placeholder: "Please add your LinkedIn URL here",
    },
  ];

  renderSocialMediaFields = (
    values: SocialMediaLinks,
    handleChange: any,
    handleBlur: any
  ) =>
    this.socialMediaFields.map(({ name, label, icon, placeholder }) => (
      <Box sx={{ ...webStyle.linkContainer }} key={name}>
        <Box sx={{ ...webStyle.linkBox }}>
          {icon} <Typography sx={{ marginLeft: 1 }}>{label}</Typography>
        </Box>
        <TextField
          fullWidth
          placeholder={placeholder}
          variant="outlined"
          value={values[name as keyof SocialMediaLinks]}
          onChange={handleChange}
          onBlur={handleBlur}
          name={name}
          sx={{ ...webStyle.input }}
          style={{ flex: 1, minWidth: "auto" }}
        />
      </Box>
    ));

  portfolioFields = [
    {
      name: "portfolioLink1",
      label: "Previous Work Link 1",
      placeholder: "Please add your previous work URL here",
    },
    {
      name: "portfolioLink2",
      label: "Previous Work Link 2",
      placeholder: "Please add your previous work URL here",
    },
    {
      name: "portfolioLink3",
      label: "Previous Work Link 3",
      placeholder: "Please add your previous work URL here",
    },
    {
      name: "portfolioLink4",
      label: "Previous Work Link 4",
      placeholder: "Please add your previous work URL here",
    },
    {
      name: "portfolioLink5",
      label: "Previous Work Link 5",
      placeholder: "Please add your previous work URL here",
    },
  ];

  renderPortfolioField = (
    {
      name,
      label,
      placeholder,
    }: { name: string; label: string; placeholder: string },
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    touched: any
  ) => (
    <Box sx={webStyle.linkContainer} key={name}>
      <Box sx={webStyle.linkBox}>
        <Typography>{label}</Typography>
      </Box>
      <TextField
        fullWidth
        placeholder={placeholder}
        variant="outlined"
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        name={name}
        sx={webStyle.input}
        style={{ flex: 1, minWidth: "auto" }}
        error={touched[name] && !!errors[name]}
        helperText={touched[name] && errors[name]}
      />
    </Box>
  );

  renderProfileImagePreview = () => {
    const { selectedProfileImagePreview } = this.state;
    if (!selectedProfileImagePreview) return null;

    return (
      <Box sx={webStyle.profilePicModalImg}>
        <Box
          component="img"
          src={selectedProfileImagePreview}
          height="100%"
          width="100%"
          alt="edit-profile-img"
        />
      </Box>
    );
  };

  renderProfileActionButtons = () => (
    <Box sx={webStyle.profilePicModalBtnCon}>
      <input
        type="file"
        id="profile-pic-upload"
        style={{ display: "none" }}
        accept="image/jpeg, image/png"
        data-test-id="imageProfileUpload"
        onChange={(e) => this.handleFileChange(e, "profile")}
      />
      <label htmlFor="profile-pic-upload">
        <Box sx={webStyle.profilePicModalUpload}>Browse</Box>
      </label>
      <Button
        sx={webStyle.profilePicModalUpload}
        data-test-id="userProfileUpload"
        disabled={!this.state.image}
        onClick={this.userProfileUpload}
      >
        Upload
      </Button>
      <Button
        sx={webStyle.profilePicModalDelete}
        data-test-id="handleProfiledelete"
        onClick={this.userProfileDelete}
      >
        Delete
      </Button>
    </Box>
  );

  renderCoverImagePreview = () => {
    const { selectedCoverImagePreview } = this.state;
    if (!selectedCoverImagePreview) return null;

    return (
      <Box sx={webStyle.coverPicModalImg}>
        <Box
          component="img"
          src={selectedCoverImagePreview}
          width="100%"
          height="100%"
          alt="cover-preview"
        />
      </Box>
    );
  };

  renderCoverPhotoActions = () => (
    <Box sx={webStyle.profilePicModalBtnCon} data-test-id="uploadCoverBox">
      <input
        type="file"
        id="cover-pic-upload"
        style={{ display: "none" }}
        accept="image/jpeg, image/png"
        data-test-id="imageCoverUpload"
        onChange={(e) => this.handleFileChange(e, "cover")}
      />
      <label htmlFor="cover-pic-upload">
        <Box sx={webStyle.profilePicModalUpload}>Browse</Box>
      </label>
      <Button
        sx={webStyle.profilePicModalUpload}
        data-test-id="userCoverUpload"
        disabled={!this.state.image}
        onClick={this.userCoverUpload}
      >
        Upload
      </Button>
      <Button
        sx={webStyle.profilePicModalDelete}
        data-test-id="handleCoverdelete"
        onClick={this.userCoverDelete}
      >
        Delete
      </Button>
    </Box>
  );
  // Customizable Area End

  render() {
    // Customizable Area Start
    const { navigation } = this.props;
    const {
      isLoading,
      isInfoDialog,
      infoMessage,
      infoType,
      profileImgPreview,
    } = this.state;

    return (
      <TypographyView>
        <NavigationMenu
          profilePicture={this.canEditProfile() ? profileImgPreview : undefined}
          navigation={navigation}
          id={""}
        />
        <FullPageLoader isLoading={isLoading} />
        <Box sx={{ backgroundColor: "#EFF6FF" }}>
          {this.renderCoverImage()}
          <Box className="profile-details">
            {this.renderProfileDetails()}
            {this.renderProfessionalSkills()}
            {this.renderAboutDetails()}
            {this.renderCareerHightlights()}
            {this.renderPortfolioSection()}
            {this.renderEducation()}
            {this.renderPortfolioLinks()}
            {this.renderSocialMediaLinks()}
          </Box>

          <GoogleAd responsive format="auto" sx={{ mt: 6 }} slot="1048726503" />
        </Box>
        <AppFooter navigation={navigation} />

        <CommonModal
          data-test-id="modalVisible"
          open={this.state.isProfileModalOpen}
          onClose={this.handleCloseProfileModal}
          title="Edit Profile Picture"
        >
          <Box sx={webStyle.profilePicModalInsideCon}>
            {this.renderProfileImagePreview()}

            <Typography component="h4" sx={webStyle.profilePicModalHeading}>
              Upload Profile Picture
            </Typography>
            <Typography sx={webStyle.profilePicModalDesc}>
              (Maximum file size is 10MB and format should be JPEG or PNG)
            </Typography>
            {this.renderProfileActionButtons()}
            {this.state.imageError && (
              <FormHelperText style={{ color: "#d32f2f" }}>
                {this.state.imageError}
              </FormHelperText>
            )}
          </Box>
        </CommonModal>

        <CommonModal
          data-test-id="handleCoverPhoto"
          open={this.state.isCoverPhotoModalOpen}
          onClose={this.handleCloseProfileCoverModal}
          title="Edit Cover Photo"
        >
          <Box sx={webStyle.profilePicModalInsideCon}>
            {this.renderCoverImagePreview()}
            <Typography sx={webStyle.profilePicModalDesc}>
              Upload Cover Photo (Maximum file size is 10MB and format should be
              JPEG or PNG)
            </Typography>
            {this.renderCoverPhotoActions()}
            {this.state.imageError && (
              <FormHelperText style={{ color: "#d32f2f" }}>
                {this.state.imageError}
              </FormHelperText>
            )}
          </Box>
        </CommonModal>

        <CommonModal
          data-test-id="handlePortfolioPhoto"
          open={this.state.iseditPortfolioImgOpen}
          onClose={this.handleEditPortfolioModalClose}
          title={"Edit Portfolio Media"}
        >
          <Box sx={{ ...webStyle.profilePicModalInsideCon }}>
            <Box sx={{ ...webStyle.portfolioModalImg }}>
              {this.renderSelectedPortfolioMedia()}
            </Box>
            <Typography
              component={"h4"}
              sx={{ ...webStyle.profilePicModalHeading }}
            >
              Upload Portfolio Media
            </Typography>
            <Typography sx={{ ...webStyle.profilePicModalDesc }}>
              Only support .JPG, .PNG, .SVG, MP4, AVI, MP3 and PDF files.
              <br />
              (The maximum file size for photos is 10MB and videos is 100MB)
            </Typography>
            <Box sx={{ ...webStyle.profilePicModalBtnCon }}>
              <input
                type="file"
                accept="image/*,video/*,audio/*,application/pdf"
                onChange={this.handleImageChange}
                data-test-id="handleImageChange"
                style={{ display: "none" }}
                ref={this.fileInput}
              />
              <Button
                sx={{ ...webStyle.profilePicModalUpload }}
                onClick={() => this.fileInput.current?.click()}
                data-test-id="newUpload"
              >
                Upload
              </Button>
              <Button
                sx={{ ...webStyle.profilePicModalDelete }}
                onClick={this.handleEditPortfolioModalClose}
              >
                Cancel
              </Button>
            </Box>
            <Typography
              sx={{ ...webStyle.errorMessage }}
              data-test-id="portfolio-error-message"
            >
              {this.state.validPortfolioError}
            </Typography>
          </Box>
        </CommonModal>

        <CustomConfirmationDialog
          isOpen={this.state.isdeletePortfolioImgOpen}
          actionBtnTitle="Delete"
          title="Delete Portfolio Media"
          subTitle="Are you sure you want to delete this Portfolio Media?"
          handleAction={this.handleConfirmDelete}
          handleClose={() => this.setState({ isdeletePortfolioImgOpen: false })}
        />

        <CommonModal
          data-test-id="handleEditAbout"
          open={this.state.isEditAboutOpen}
          onClose={() => this.setState({ isEditAboutOpen: false })}
          title={"Edit About"}
        >
          <Typography sx={{ ...webStyle.aboutTitleModalInsideCon }}>
            About Me
            <span style={webStyle.aboutSpanTextModalInsideCon}>
              (Max character limit 1000)
            </span>
          </Typography>
          <Box sx={{ ...webStyle.aboutModalInsideCon }}>
            <TextField
              data-test-id="handleAboutChange"
              fullWidth
              multiline
              minRows={6}
              maxRows={12}
              value={this.state.editedAbout}
              onChange={this.handleAboutChange}
              inputProps={{
                maxLength: 1000,
              }}
            />
          </Box>
          <Box sx={{ ...webStyle.aboutModalButtonBox }}>
            <CustomButton
              fullWidth
              customVariant="filled"
              data-test-id="saveBtn"
              sx={{ height: "56px", maxWidth: "360px" }}
              onClick={this.editUserProfile}
              disabled={
                this.state.editedAbout.length === 0 ||
                this.state.editedAbout.length > 1000
              }
            >
              Save
            </CustomButton>
          </Box>
        </CommonModal>

        {this.state.isCareerModalOpen && (
          <EditCareerHighlights
            data-test-id="handleCloseCareerModal"
            open={this.state.isCareerModalOpen}
            onClose={this.handleCloseCareerModal}
            onSave={this.handleSaveCareerHighlights}
            careerData={this.state.selectedCareerHighlight}
          />
        )}
        {this.state.isEducationModalOpen && (
          <EducationModal
            data-test-id="handleCloseEducationModal"
            open={this.state.isEducationModalOpen}
            onClose={this.handleCloseEducationModal}
            onSave={this.handleSaveEducationDetails}
            educationData={this.state.selectedEducation}
          />
        )}

        <CommonModal
          data-test-id="handleClosePortfolioModal"
          open={this.state.isPortfolioModalOpen}
          onClose={this.handleClosePortfolioModal}
          title="Edit Previous Work Links"
        >
          <Formik
            data-test-id="userEditPortfolio"
            enableReinitialize
            initialValues={this.state.portfolioLinks}
            validationSchema={this.validationPortfolioLinkSchema}
            onSubmit={(values) => this.userEditPortfolioLink(values)}
          >
            {({ values, handleChange, handleBlur, errors, touched }) => (
              <Form data-test-id="portfolioForm">
                <Box sx={webStyle.socialContainer}>
                  {this.portfolioFields.map((field) =>
                    this.renderPortfolioField(
                      field,
                      values,
                      handleChange,
                      handleBlur,
                      errors,
                      touched
                    )
                  )}
                  <Box
                    sx={webStyle.aboutModalButtonBox}
                    style={{ textAlign: "right", width: "100%" }}
                  >
                    <Button
                      data-test-id="saveBtn"
                      sx={webStyle.aboutSaveModal}
                      style={{ minWidth: 120 }}
                      type="submit"
                      variant="contained"
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              </Form>
            )}
          </Formik>
        </CommonModal>

        <CommonModal
          data-test-id="handleSocialModal"
          open={this.state.isSocialMediaModalOpen}
          onClose={this.handleCloseSocialModal}
          title={"Edit Social Media Links"}
        >
          <Formik
            data-test-id="userEditSocial"
            enableReinitialize
            initialValues={this.getInitialSocialLinks()}
            onSubmit={(values: SocialMediaLinks) => this.userEditSocial(values)}
          >
            {({ values, handleChange, handleBlur }) => (
              <Form data-test-id="form">
                <Box sx={{ ...webStyle.socialContainer }}>
                  {this.renderSocialMediaFields(
                    values,
                    handleChange,
                    handleBlur
                  )}

                  <Box
                    sx={{ ...webStyle.aboutModalButtonBox }}
                    style={{ textAlign: "right", width: "100%" }}
                  >
                    <Button
                      data-test-id="saveBtn"
                      sx={{ ...webStyle.aboutSaveModal }}
                      style={{ minWidth: 120 }}
                      type="submit"
                      variant="contained"
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              </Form>
            )}
          </Formik>
        </CommonModal>

        <CommonModal
          data-test-id="handleCloseBasicModal"
          open={this.state.isBasicInfoModalOpen}
          onClose={this.handleCloseBasicModal}
          title="Edit Basic Information"
        >
          <Box sx={{ ...modalStyle.basicInfoModal }}>
            <Box sx={{ ...modalStyle.modalFieldBox }}>
              <Box style={{ width: "100%" }}>
                <FormField
                  data-test-id="first-name-input"
                  label="First Name"
                  name="firstName"
                  value={this.state.tempProfileData.firstName}
                  onChange={this.handleChange}
                  placeholder="Enter your First Name"
                  error={this.state.errors.firstName}
                  inputProps={{ maxLength: 30 }}
                />
              </Box>
              <Box style={{ width: "100%" }}>
                <FormField
                  data-test-id="lastName-input"
                  label="Last Name"
                  name="lastName"
                  value={this.state.tempProfileData.lastName}
                  onChange={this.handleChange}
                  placeholder="Enter your Last Name"
                  error={this.state.errors.lastName}
                  inputProps={{ maxLength: 30 }}
                />
              </Box>
            </Box>
            <Box sx={{ ...modalStyle.modalFieldBox }}>
              <Box style={{ width: "100%" }}>
                <Typography sx={{ ...webStyle.fieldsTitle }}>
                  Location
                </Typography>
                <FormControl fullWidth sx={{ ...webStyle.input }}>
                  <Select
                    name="location"
                    data-test-id="location"
                    onChange={this.handleLocationChange}
                    IconComponent={KeyboardArrowDownRoundedIcon}
                    value={this.state.tempProfileData.location || ""}
                    defaultValue=""
                    displayEmpty
                    MenuProps={{
                      sx: {
                        "& .MuiPaper-root": {
                          width: "auto !important",
                          minWidth: "100%",
                        },
                      },
                      PaperProps: {
                        sx: {
                          maxHeight: 200,
                          overflowY: "auto",
                          minWidth: "unset",
                        },
                      },
                    }}
                  >
                    <MenuItem value="" sx={{ display: "none" }}>
                      Select your Location
                    </MenuItem>
                    {this.state.locationOptions.map(
                      (location: LocationOption) => (
                        <MenuItem key={location.key} value={location.value}>
                          {location.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
                {this.state.errors.location && (
                  <FormHelperText style={{ color: "#D30000" }}>
                    {this.state.errors.location}
                  </FormHelperText>
                )}
              </Box>
              <Box style={{ width: "100%" }}>
                <FormField
                  data-test-id="languageSelect"
                  label="Language Spoken"
                  name="selectedLanguages"
                  value={this.state.tempProfileData.selectedLanguages}
                  onChange={this.handleLanguageChange}
                  options={this.state.languageOptions}
                  placeholder="Choose language"
                  multiple
                  isSelect={true}
                  isChipsField={true}
                  renderValue={(selected: string[]) =>
                    selected.length === 0
                      ? "Choose language"
                      : selected.join(", ")
                  }
                  error={this.state.errors.selectedLanguages}
                  handleDeleteChip={this.handleDeleteLanguage}
                />
              </Box>
            </Box>
            <Box sx={{ ...modalStyle.modalFieldBox }}>
              <Box style={{ width: "100%" }}>
                <FormField
                  data-test-id="heightField"
                  label="Height (In cm)"
                  name="height"
                  value={this.state.tempProfileData.height}
                  onChange={this.handleChange}
                  placeholder="Enter your Height (In cm)"
                  error={this.state.errors.height}
                />
              </Box>
              <Box style={{ width: "100%" }}>
                <FormField
                  data-test-id="weightField"
                  label="Weight (In kg)"
                  name="weight"
                  value={this.state.tempProfileData.weight}
                  onChange={this.handleChange}
                  placeholder="Enter your Weight (In kg)"
                  error={this.state.errors.weight}
                />
              </Box>
            </Box>
            <Box sx={{ ...modalStyle.modalFieldBox }}>
              <Box style={{ width: "100%" }}>
                <FormField
                  data-test-id="age"
                  label="Age (Years)"
                  name="age"
                  value={this.state.tempProfileData.age}
                  onChange={this.handleChange}
                  placeholder="Enter your Age (Years)"
                  error={this.state.errors.age}
                />
              </Box>
              <Box style={{ width: "100%" }}>
                <Typography sx={{ ...webStyle.fieldsTitle }}>Gender</Typography>
                <FormControl fullWidth sx={{ ...webStyle.input }}>
                  <Select
                    name="gender"
                    data-test-id="gender-select"
                    onChange={this.handleGenderChange}
                    IconComponent={KeyboardArrowDownRoundedIcon}
                    value={this.state.tempProfileData.userGender || ""}
                    defaultValue=""
                    displayEmpty
                  >
                    <MenuItem value="" sx={{ display: "none" }}>
                      Select your Gender
                    </MenuItem>
                    {configJSON.gender.map(
                      (genDetails: { key: string; value: string }) => (
                        <MenuItem key={genDetails.key} value={genDetails.key}>
                          {genDetails.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
                {this.state.errors.userGender && (
                  <FormHelperText style={{ color: "#D30000" }}>
                    {this.state.errors.userGender}
                  </FormHelperText>
                )}
              </Box>
            </Box>
            <Box sx={{ ...webStyle.aboutModalButtonBox, marginTop: "30px" }}>
              <Button
                sx={{ ...webStyle.aboutSaveModal }}
                data-test-id="save-btn"
                onClick={this.handleSubmitBasicInfo}
              >
                Save
              </Button>
            </Box>
          </Box>
        </CommonModal>

        <ImagePreviewDialog
          open={this.state.isMediaModalOpen}
          imageUrl={this.state.expandedMedia}
          onClose={this.handleCloseMediaDialog}
        />

        <CommonModal
          data-test-id="handleCloseProfessionalModal"
          open={this.state.isProfessionalModalOpen}
          onClose={this.handleCloseProfessionalModal}
          title="Edit Professional Skills"
        >
          <Box sx={{ ...modalStyle.professionModal }}>
            <Box sx={{ ...modalStyle.modalFieldBox }}>
              {this.renderCategorySelect()}
              {this.renderSubCategorySelect()}
            </Box>
            {this.renderSelectedSkills()}
            <Box sx={{ ...webStyle.professionalModalBtnBox }}>
              <Button
                sx={{ ...webStyle.aboutSaveModal }}
                data-test-id="saveSkillButton"
                onClick={this.handleSaveProfessionalSkills}
              >
                Save
              </Button>
            </Box>
          </Box>
        </CommonModal>

        <CustomConfirmationDialog
          isOpen={this.state.isDeleteSkillModal}
          actionBtnTitle="Delete"
          title="Delete Professional Skill"
          subTitle="Are you sure you want to delete this Professional Skill?"
          handleAction={this.userDeleteProfessionalSkills}
          handleClose={() => this.setState({ isDeleteSkillModal: false })}
        />

        <CustomConfirmationDialog
          isOpen={this.state.isDeleteCareerHighlightModal}
          actionBtnTitle="Delete"
          title="Delete Career Highlight"
          subTitle="Are you sure you want to delete this Career Highlight?"
          handleAction={this.handleConfirmDeleteCareerHighlight}
          handleClose={() =>
            this.setState({ isDeleteCareerHighlightModal: false })
          }
        />

        <CustomConfirmationDialog
          isOpen={this.state.isDeleteEducationModal}
          actionBtnTitle="Delete"
          title="Delete Education And Training"
          subTitle="Are you sure you want to delete this Education And Training?"
          handleAction={this.handleConfirmDeleteEducation}
          handleClose={() => this.setState({ isDeleteEducationModal: false })}
        />

        <CustomInfoDialog
          infoType={infoType}
          title={infoMessage}
          isOpen={isInfoDialog}
          handleClose={this.closeInfoDialog}
        />
      </TypographyView>
      // Customizable Area End
    );
    // Customizable Area End
  }
}

// Customizable Area Start
const modalStyle = {
  basicInfoModal: {
    maxHeight: "90vh",
    overflowY: "auto",
    overflowX: "auto",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#CBD5E1",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#A1A1A1",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "@media (max-width: 920px)": {
      width: "auto",
      padding: "15px",
    },
  },
  professionModal: {
    maxHeight: "90vh",
    overflowY: "auto",
    padding: "30px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    "&:focus": {
      outline: "none",
    },
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#CBD5E1",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#A1A1A1",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "@media (max-width: 920px)": {
      width: "90%",
      padding: "20px",
    },
    "@media (max-width: 600px)": {
      padding: "15px",
    },
  },
  modalFieldBox: {
    display: "flex",
    gap: "20px",
    marginBottom: "15px",
    marginTop: "15px",
    flexDirection: "column",

    "@media (min-width: 930px)": {
      flexDirection: "row",
    },
  },
  languageBox: {
    display: "flex",
  },
};

const webStyle = {
  modalInsideContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "30px",
    border: "1px solid #94A3B8",
    borderRadius: "20px",
  },
  modalTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  imageExpand: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "10px",
    overflowY: "auto",
    bgcolor: "#FFFFFF",
    boxShadow: 24,
    borderRadius: "20px",
    width: "480px",
    "@media (max-width: 510px)": {
      width: "95%",
    },
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "24.38px",
  },
  closeIcon: {
    position: "absolute" as "absolute",
    top: "10px",
    right: "10px",
    zIndex: 10,
    "& svg": {
      fontSize: "24px",
      fill: "#000",
    },
  },
  fieldsTitle: {
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "22px",
    fontFamily: "Montserrat !important",
    marginBottom: "5px",
    "@media (max-width: 550px)": {
      fontSize: "14px",
      lineHeight: "18px",
    },
  },
  profilePicModalInsideCon: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    margin: "30px",
    padding: "30px",
    border: "1px dashed #94A3B8",
    borderRadius: "20px",
    "@media (max-width: 550px)": {
      padding: "15px",
      margin: "15px 0px 0px 0px",
      width: "95%",
    },
  },
  aboutTitleModalInsideCon: {
    marginTop: "20px",
    marginBottom: "5px",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "22px",
    color: "#0F172A",
  },
  errorMessage: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "6px",
    color: "#E11B23",
    marginTop: "15px",
  },
  portfolioBox: {
    display: "flex",
    gap: 1,
    marginBottom: "20px",
    width: "100%",
    flexWrap: "wrap",
    "@media (max-width: 550px)": {
      display: "flex",
      flexDirection: "column",
    },
  },
  portfolioContainer: {
    display: "flex",
    gap: 2,
    maxHeight: "80vh",
    overflowY: "auto",
    padding: 2,
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "flex-start", md: "center" },
  },
  socialContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    maxHeight: "80vh",
    overflowY: "auto",
    padding: 2,
  },
  aboutSpanTextModalInsideCon: {
    fontSize: "14px",
    fontWeight: "300",
    lineHeight: "22px",
    color: "#0F172A",
    marginLeft: "4px",
    fontFamily: "Montserrat !important",
  },
  aboutModalInsideCon: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    borderRadius: "20px",
    "& .MuiInputBase-root": {
      borderRadius: "32px",
      padding: "20px",
      "&:hover": {
        "& fieldset": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
      },
    },
    "@media (max-width: 550px)": {
      padding: "15px",
      margin: "15px 0px 0px 0px",
    },
  },
  input: {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#64748b !important",
    opacity: "1 !important",
    "& .MuiOutlinedInput-root": {
      borderRadius: "50px",
      borderColor: "#e2e8f0",
      "&:hover": { borderColor: "#cbd5e1" },
      "&.Mui-focused": {
        borderColor: "#673ab7",
        boxShadow: "0 0 0 3px rgba(103, 58, 183, 0.2)",
      },
    },
  },
  categoryListing: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
    my: 1,
    ml: 3,
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      ml: 0,
    },
  },
  deleteBtn: {
    borderRadius: "80px",
    padding: "5px",
    border: "1px solid #CBD5E1",
  },
  linkBox: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    minWidth: 120,
    justifyContent: "flex-start",
    whiteSpace: "nowrap",
  },
  linkContainer: {
    display: "flex",
    marginBottom: "15px",
    flexDirection: { xs: "column", md: "row" },
    alignItems: { xs: "flex-start", md: "center" },
    gap: 1,
    width: "100%",
    flexWrap: "wrap",
  },
  profilePicModalImg: {
    width: "189px",
    height: "189px",
    overflow: "hidden",
    borderRadius: "100px",
    "& img": {
      objectFit: "cover",
    },
    "@media (max-width: 550px)": {
      width: "150px",
      height: "150px",
    },
  },
  coverPicModalImg: {
    width: "100%",
    height: "189px",
    overflow: "hidden",
    borderRadius: "20px",
    "& img": {
      objectFit: "cover",
    },
  },
  portfolioModalImg: {
    width: "189px",
    height: "189px",
    overflow: "hidden",
    borderRadius: "10px",
    border: "1px solid",
    "@media (max-width: 550px)": {
      width: "150px",
      height: "150px",
    },
  },
  profilePicModalHeading: {
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "19.5px",
    color: "#0F172A",
    marginTop: "20px",
    "@media (max-width: 414px)": {
      fontSize: "12px",
      lineHeight: "15px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "14px",
      lineHeight: "17px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "18px",
      lineHeight: "21px",
    },
  },
  browseBtn: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    border: "2px dashed #ccc",
    color: "#000000",
    textAlign: "center",
  },
  profilePicModalDesc: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "17.07px",
    color: "#0F172A",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    "@media (max-width: 414px)": {
      fontSize: "10px",
      lineHeight: "13px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "12px",
      lineHeight: "15px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "16px",
      lineHeight: "19px",
    },
  },
  aboutModalDesc: {
    fontSize: "16px",
    fontWeight: "300",
    lineHeight: "24px",
    color: "#0F172A",
    outline: "none",
    "@media (max-width: 414px)": {
      fontSize: "10px",
      lineHeight: "13px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "12px",
      lineHeight: "15px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "16px",
      lineHeight: "19px",
    },
  },
  profilePicModalBtnCon: {
    display: "flex",
    gap: "8px",
    "@media (max-width: 900px)": {
      display: "flex",
      flexDirection: "column",
    },
  },
  profilePicModalBotton: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    justifyContent: "center",
  },
  profilePicModalUpload: {
    fontSize: "14px !important",
    fontWeight: 600,
    width: "140px !important",
    color: "#fff !important",
    lineHeight: "24px !important",
    border: "1px solid currentColor",
    borderRadius: "32px",
    padding: "10px 39px !important",
    cursor: "pointer",
    textTransform: "none",
    background: "linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    "@media (max-width: 600px)": {
      fontSize: "12px",
      padding: "8px 39px !important",
    },
    "@media (max-width: 1280px)": {
      fontSize: "12px",
    },
  },
  aboutModalButtonBox: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    marginTop: "20px",
  },
  professionalModalBtnBox: {
    mt: "50px",
    display: "flex",
    justifyContent: "center",
    "@media (max-width: 600px)": {
      mt: "30px",
    },
  },
  aboutSaveModal: {
    fontSize: "14px !important",
    fontWeight: 600,
    width: "360px !important",
    color: "#fff !important",
    lineHeight: "24px !important",
    border: "1px solid currentColor",
    borderRadius: "32px",
    padding: "10px 39px !important",
    textTransform: "none",
    cursor: "pointer",
    background: "linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    opacity: 1,
    transition: "opacity 0.3s",
    "&:disabled": {
      opacity: 0.5,
      pointerEvents: "none",
    },
    "@media (max-width: 1280px)": {
      fontSize: "12px",
    },
    "@media (max-width: 420px)": {
      width: "270px !important",
    },
  },
  profilePicModalDelete: {
    fontSize: "14px !important",
    fontWeight: 600,
    width: "140px !important",
    color: "#652784 !important",
    lineHeight: "24px !important",
    borderRadius: "32px",
    padding: "10px 39px !important",
    border: "2px solid transparent !important",
    background:
      "linear-gradient(to right, white, white), linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    backgroundClip: "padding-box, border-box",
    backgroundOrigin: "padding-box, border-box",
    textTransform: "none",
    cursor: "pointer",
    "@media (max-width: 600px)": {
      fontSize: "12px",
      padding: "7px 39px !important",
    },
    "@media (max-width: 1280px)": {
      fontSize: "12px",
    },
  },
};
// Customizable Area End
